/**
 * @generated SignedSource<<77c2c63929be83181329f092cf637a36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type recoilDisableProviderMutation$variables = {
  provider_id: number;
};
export type recoilDisableProviderMutation$data = {
  readonly _sys_disable_provider: {
    readonly mapping_set_ids: ReadonlyArray<number>;
    readonly property_ids: ReadonlyArray<number>;
    readonly provider_id: number;
    readonly user_ids: ReadonlyArray<number>;
    readonly user_ids_to_disable_sakura: ReadonlyArray<number>;
  };
};
export type recoilDisableProviderMutation = {
  response: recoilDisableProviderMutation$data;
  variables: recoilDisableProviderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "provider_id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "provider_id",
            "variableName": "provider_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "params"
      }
    ],
    "concreteType": "disable_provider_output",
    "kind": "LinkedField",
    "name": "_sys_disable_provider",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "user_ids",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "user_ids_to_disable_sakura",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "property_ids",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mapping_set_ids",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "recoilDisableProviderMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "recoilDisableProviderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8119837950cb760780b86cb83a59b0c7",
    "id": null,
    "metadata": {},
    "name": "recoilDisableProviderMutation",
    "operationKind": "mutation",
    "text": "mutation recoilDisableProviderMutation(\n  $provider_id: Int!\n) {\n  _sys_disable_provider(params: {provider_id: $provider_id}) {\n    provider_id\n    user_ids\n    user_ids_to_disable_sakura\n    property_ids\n    mapping_set_ids\n  }\n}\n"
  }
};
})();

(node as any).hash = "0fd93d1e2708d51d28679281b3edd442";

export default node;
